angular.module("Main").controller("OnlineSalesWDRDialogController", ["BookingService", function (BookingService) {
    var vm = this;

    BookingService.getWDR().then(function (data) {
        vm.wdr = data.text.RightOfWithdrawal;
    })
}]);